export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Sneakers, Trainers & Footwear',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-t-shirt-line',
    description: 'Hoodies, Crewnecks & Knits',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-shirt-line',
    description: 'Tees, Tops & Basics',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-honour-line',
    description: 'Outerwear & Coats',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-pantone-line',
    description: 'Jeans, Trousers & Shorts',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-user-smile-line',
    description: 'Caps, Beanies & Hats',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-stack-line',
    description: 'Matching Outfits & Bundles',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Undergarments & Basics',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-star-line',
    description: 'Sports Jerseys & Kits',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-glasses-line',
    description: 'Watches, Jewelry & More',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, Totes & Handbags',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    icon: 'ri-link',
    description: 'Leather & Casual Belts',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    icon: 'ri-drop-line',
    description: 'Fragrances & Colognes',
  },
  {
    id: 'otherstuff',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    icon: 'ri-more-line',
    description: 'Everything Else',
  },
];

export const trustBadges = [
  { icon: 'ri-refresh-line', label: 'Updated Daily' },
  { icon: 'ri-shield-check-line', label: 'Trusted Sellers' },
  { icon: 'ri-book-open-line', label: 'Buying Guides' },
  { icon: 'ri-verified-badge-line', label: 'Safety Checked' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com/';